import { Customer, ShipTo } from '@next/core-lib/business-partner-aggregation-api';
import { Distance } from 'src/app/shared/models/distance.model';
import { ManureCategory } from 'src/app/shared/models/manure-category.model';
import { ManureType } from 'src/app/shared/models/manure-type.model';
import { Month } from 'src/app/shared/models/month.model';
import { PaymentType } from 'src/app/shared/models/payment-type.model';
import { Status } from 'src/app/shared/models/status.model';
import { StorageForm } from 'src/app/shared/models/storage-form.model';
import { TransportType } from 'src/app/shared/models/transport-type.model';

export interface ManureRequest {
  manureCategory: ManureCategory;
  manureType: ManureType;
  amountInTons: number;
  paymentType: PaymentType;
  pricePerTon: number;
  desiredDeliveryPeriodFrom?: Month;
  desiredDeliveryPeriodTo?: Month;
  nKgPerTon?: number;
  pKgPerTon?: number;
  kKgPerTon?: number;
  transportType?: TransportType;
  storageForm?: StorageForm;
  preferredIntermediary?: string;
  isHomogeneous?: boolean;
  customer?: Customer;
  shipTo?: ShipTo;
}

export interface ManureRequestForm {
  manureCategory: ManureCategory;
  manureType: ManureType;
  amountInTons: number;
  paymentType: PaymentType;
  pricePerTon: number;
  desiredDeliveryPeriodFrom?: Month;
  desiredDeliveryPeriodTo?: Month;
  nKgPerTon?: string;
  pKgPerTon?: string;
  kKgPerTon?: string;
  transportType?: TransportType;
  storageForm?: StorageForm;
  preferredIntermediary?: string;
  isHomogeneous?: boolean;
}

export interface ManureRequestModel extends ManureRequest {
  id: number;
  status: Status;
  distance: Distance;
}

export interface RequestExportApiModel extends ManureRequest {
  id: number;
  intermediary: string;
  createdAt: string;
  customer: Customer;
  status: Status;
  maxNitrogen?: number;
  maxPhosphate?: number;
  totalPrice: number;
}

export interface RequestExportModel extends ManureRequest {
  createdAt: Date;
  status: Status;
  maxNitrogen?: number;
  maxPhosphate?: number;
  totalPrice: number;
  customerName: string;
  customerEmailAddress: string;
  customerPhoneNumber: number;
  shipToName: string;
  shipToCity: string;
  shipToPostalCode: string;
  shipToStreet: string;
  shipToHouseNumber: string;
  shipToHouseNumberAddition: string;
  intermediary: string;
}

export const toRequestExportModel = (request: RequestExportApiModel): RequestExportModel => ({
  createdAt: new Date(request.createdAt),
  manureCategory: request.manureCategory,
  manureType: request.manureType,
  amountInTons: request.amountInTons,
  paymentType: request.paymentType,
  pricePerTon: request.pricePerTon,
  desiredDeliveryPeriodFrom: request.desiredDeliveryPeriodFrom,
  desiredDeliveryPeriodTo: request.desiredDeliveryPeriodTo,
  nKgPerTon: request.nKgPerTon,
  pKgPerTon: request.pKgPerTon,
  kKgPerTon: request.kKgPerTon,
  transportType: request.transportType,
  isHomogeneous: request.isHomogeneous,
  status: request.status,
  maxNitrogen: request.maxNitrogen,
  maxPhosphate: request.maxPhosphate,
  totalPrice: request.totalPrice,
  customerName: request.customer.name,
  customerEmailAddress: request.customer.emailAddress,
  customerPhoneNumber: request.customer.phoneNumber,
  shipToName: request.shipTo.name,
  shipToCity: request.shipTo.city,
  shipToPostalCode: request.shipTo.postalCode,
  shipToStreet: request.shipTo.street,
  shipToHouseNumber: request.shipTo.houseNumber,
  shipToHouseNumberAddition: request.shipTo.houseNumberAddition,
  intermediary: request.intermediary,
});
